import React from 'react';

import type { InputRadioGroupProps } from '../InputRadioGroup';
import InputRadioGroup from '../InputRadioGroup';

const InputRadioGroupSchema = (props: InputRadioGroupProps) => <InputRadioGroup {...props} />;

export default InputRadioGroupSchema;
